import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditProductComponent } from '../edit-product.component';
import { ToastrService } from 'ngx-toastr';
import { Component, Injectable, Inject, EventEmitter, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';

export class TodoItemNode {
  id: string;
  name: string;
  path: string;
  children: TodoItemNode[];
  parent_id: string;
}

export class TodoItemFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  path: string;
  id: string;
  parent_id: string;
}

let TREE_DATA = [];

@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<TodoItemNode[]>([]);

  dataTree = [];

  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }

  constructor(
    public dialogRef: MatDialogRef<EditProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data_tree
  ) {
    this.getTreeData(this.data_tree.treeData);
  }

  initialize() {
    const data = this.buildFileTree(TREE_DATA, 0);
    this.dataChange.next(data);
  }

  getTreeData(data): Observable<any> {
    this.dataTree = data;
    TREE_DATA = this.buildTree(this.dataTree);
    this.initialize();
    return;
  }

  buildTree(data) {
    let rootNode = data.filter((x) => x.parent_id == null);
    let treeobject = [];
    rootNode.forEach((element) => {
      let aChildren = data.filter((x) => x.parent_id == element.id);
      const node = new TodoItemNode();
      node.id = element.id;
      node.name = element.name;
      node.parent_id = element.parent_id;
      node.path = element.name;
      let lstChildren = this.builDataChildren(aChildren, data, node);
      node.children = lstChildren;
      treeobject.push(node);
    });
    return treeobject;
  }

  builDataChildren(aChildren, allChildren, parent) {
    let objectReturn = [];
    aChildren.forEach((element) => {
      let aChild = allChildren.filter((x) => x.parent_id == element.id);
      const node = new TodoItemNode();
      node.id = element.id;
      node.name = element.name;
      node.path = parent.path + ' › ' + element.name;
      let lstChildrenNode = this.builDataChildren(aChild, allChildren, node);
      node.children = lstChildrenNode;
      objectReturn.push(node);
    });
    return objectReturn;
  }

  buildFileTree(obj, level: number): TodoItemNode[] {
    return obj.reduce((accumulator: any, item) => {
      const node = new TodoItemNode();
      node.id = item.id;
      node.name = item.name;
      node.path = item.path;
      node.parent_id = item.parent_id;
      if (item.children != undefined) {
        if (item.children.length > 0) {
          node.children = this.buildFileTree(item.children, level + 1);
        } else {
          node.id = item.id;
          node.name = item.name;
          node.path = item.path;
          node.parent_id = item.parent_id;
        }
      }
      return accumulator.concat(node);
    }, []);
  }

  public filter(filterText: string) {
    let filteredTreeData;
    if (filterText) {
      filteredTreeData = TREE_DATA.filter(
        (d) => d.name.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1
      );
      Object.assign([], filteredTreeData).forEach((ftd) => {
        let str = <string>ftd.name;
        while (str.lastIndexOf('.') > -1) {
          const index = str.lastIndexOf('.');
          str = str.substring(0, index);
          if (filteredTreeData.findIndex((t) => t.name === str) === -1) {
            const obj = TREE_DATA.find((d) => d.name === str);
            if (obj) {
              filteredTreeData.push(obj);
            }
          }
        }
      });
    } else {
      filteredTreeData = TREE_DATA;
    }

    const data = this.buildFileTree(filteredTreeData, 0);
    this.dataChange.next(data);
  }
}

@Component({
  selector: 'meu-modal-tree-category',
  templateUrl: './modal-tree-category.component.html',
  styleUrls: ['./modal-tree-category.component.scss'],
  providers: [ChecklistDatabase],
})
export class ModalTreeCategoryComponent implements OnInit {
  choosePath = '';
  @Output() currentNode = new EventEmitter<string>();

  private _transformer = (node: TodoItemNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      path: node.path,
      id: node.id,
    };
  };

  treeControl = new FlatTreeControl<TodoItemFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: TodoItemFlatNode) => node.expandable;
  displayedColumns: string[] = ['index', 'name', 'code', 'address'];

  selectedNode: any = null;
  nodeIndex: number;

  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

  constructor(
    public dialogRef: MatDialogRef<EditProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private toastr: ToastrService,
    private database: ChecklistDatabase
  ) {
    this.dataSource.data = TREE_DATA;

    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    database.dataChange.subscribe((data) => {
      this.dataSource.data = data;
    });
  }

  getLevel = (node: TodoItemFlatNode) => node.level;
  isExpandable = (node: TodoItemFlatNode) => node.expandable;
  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close({ event: false });
  }

  save() {
    if (!this.selectedNode) {
      this.toastr.warning('Vui lòng chọn danh mục sản phẩm');
      return;
    }
    this.choosePath = this.selectedNode.path;
    this.dialogRef.close({ event: true, path: this.choosePath, id: this.selectedNode.id });
  }

  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.name === node.name ? existingNode : new TodoItemFlatNode();
    flatNode.name = node.name;
    flatNode.path = node.path;
    flatNode.level = level;
    flatNode.id = node.id;
    flatNode.expandable = !!node.children;
    flatNode.parent_id = node.parent_id;

    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };
  filterChanged(filterText: string) {
    this.database.filter(filterText);
    if (filterText) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }
  getCurrentNode(node, index) {
    this.nodeIndex = index;
    this.selectedNode = node;
    this.choosePath = this.selectedNode.path;
    this.currentNode.emit(node);
  }
}
